<template>
  <div class="d-flex">
    <div class="position-absolute" style="top: 10px; right: 15px; z-index:1;">
      <div class="ml-auto">
        <i
          @click="$emit('edit', order)"
          class="fas fa-edit text-success hover-pointer"
          style="font-size: 14px"
        ></i>
        <i
          @click="$emit('delete', order)"
          class="fas fa-trash-alt text-danger hover-pointer ml-2"
          style="font-size: 14px"
        ></i>
      </div>
    </div>

    <div class="d-flex flex-column align-items-center" style="gap: 26px;">
      <div class="circle">
        {{ order + 1 }}
      </div>
      <span class="cursor-pointer" style="color: lightgray">
        <i class="fa fa-ellipsis-v dragger-icon" aria-hidden="true"></i>
        <i class="fa fa-ellipsis-v dragger-icon" aria-hidden="true"></i>
      </span>
    </div>
    <section class="ml-3">
      <article>
        <span class="text">Conditions: </span>
        <div v-for="(statement, index) in condition.statements" :key="index">
          <span class="text">{{ getTitleString(statement.field) }} = </span>
          <span class="detail-text">{{
            findStatementsDetails(statement.field, statement.value)
          }}</span
          ><br /><span class="text">
            {{ statement.logicalOperator }}
          </span>
        </div>
      </article>

      <article>
        <div class="text">Fee and codes:</div>
        <span class="text" v-if="condition.costVariation"
          >Cost per unit =
        </span>
        <span class="detail-text" v-if="condition.costVariation">{{
          condition.costVariation
        }}</span>
        <div v-if="billingCode">
          <span class="text">Billing Code = </span>
          <span class="detail-text">{{ billingCode }}</span>
        </div>
        <div v-if="mod1">
          <span class="text">Modifier 1 = </span>
          <span class="detail-text">{{ mod1 }}</span>
        </div>
        <div v-if="mod2">
          <span class="text">Modifier 2 = </span>
          <span class="detail-text">{{ mod2 }}</span>
        </div>
        <div v-if="mod3">
          <span class="text">Modifier 3 = </span>
          <span class="detail-text">{{ mod3 }}</span>
        </div>
        <div v-if="mod4">
          <span class="text">Modifier 4 = </span>
          <span class="detail-text">{{ mod4 }}</span>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "ServiceCostVariationRuleItem",
  props: [
    "condition",
    "order",
    "payors",
    "credentials",
    "scheduleEventStatuses",
    "billingCode",
    "mod1",
    "mod2",
    "mod3",
    "mod4"
  ],
  methods: {
    getTitleString(field) {
      switch (field) {
        case "payor":
          return "Payor";
        case "supervisorCredentials":
          return "Supervisor Credentials";
        case "appStatus":
          return "Appointment";
        default:
          return "Credentials";
      }
    },
    findStatementsDetails(source, id) {
      if (id) {
        switch (source) {
          case "payor":
            return this.payors.records.find(item => item.id === id).name;
          case "credentials":
            return this.credentials.find(item => item.id === id).name;
          case "supervisorCredentials":
            return this.credentials.find(item => item.id === id).name;
          case "appStatus":
            return this.scheduleEventStatuses.find(status => status.id === id)
              .name;
          default:
            return "";
        }
      }
    }
  }
});
</script>

<style>
.circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #707070;
  font-size: 12px;
}

.dragger-icon {
  font-size: 17px;
  color: #b9b9b9;
}

.text {
  font-size: 12px;
  font-weight: bold;
}

.detail-text {
  font-size: 12px;
}
</style>
